import { Link, useLocation } from 'react-router-dom';
import { Clock, Lock } from 'lucide-react';
import { useAuth } from '../hooks/useAuth';

export default function TrialBanner() {
  const { tenant } = useAuth();
  const { pathname } = useLocation();

  if (!tenant || pathname.startsWith('/planos')) return null;

  const isTrial = tenant.status === 'trial' && tenant.trialEndsAt;
  const isSuspended = tenant.status === 'suspended';
  if (!isTrial && !isSuspended) return null;

  const daysLeft = isTrial
    ? Math.ceil((new Date(tenant.trialEndsAt) - Date.now()) / (1000 * 60 * 60 * 24))
    : 0;
  const expired = isSuspended || daysLeft <= 0;

  if (expired) {
    return (
      <div className="flex flex-wrap items-center justify-center gap-x-3 gap-y-1.5 px-4 py-2.5 bg-coral-600 text-white text-[13.5px] font-medium text-center">
        <Lock size={15} className="shrink-0" />
        <span>
          {isSuspended
            ? 'Assinatura suspensa por falta de pagamento, e o acesso está bloqueado.'
            : 'Seu período gratuito de 1 mês terminou, e o acesso está bloqueado.'}
        </span>
        <Link to="/planos" className="underline font-semibold hover:text-coral-100">
          Assinar agora
        </Link>
      </div>
    );
  }

  return (
    <div className="flex flex-wrap items-center justify-center gap-x-3 gap-y-1.5 px-4 py-2.5 bg-jade-600 text-white text-[13.5px] font-medium text-center">
      <Clock size={15} className="shrink-0" />
      <span>
        Período gratuito: {daysLeft === 1 ? 'último dia' : `${daysLeft} dias restantes`}. Depois
        disso, o acesso é bloqueado até a assinatura.
      </span>
      <Link to="/planos" className="underline font-semibold hover:text-jade-100">
        Assinar agora
      </Link>
    </div>
  );
}
